import {Component, Input, OnInit} from '@angular/core';
import {CloudStatusType} from '../support.service';

@Component({
    selector: 'app-cloud-status',
    templateUrl: './cloud-status.component.html',
    standalone: false
})
export class CloudStatusComponent implements OnInit {

  @Input()
  status: CloudStatusType;

  constructor() { }

  ngOnInit(): void { }

  get operational(): boolean {
    return this.status === 'operational';
  }

  get degraded(): boolean {
    return this.status === 'degraded';
  }

  get outage(): boolean {
    return this.status === 'outage';
  }

}
